import { render, staticRenderFns } from "./MenuPreview.vue?vue&type=template&id=2c8b92f8&scoped=true"
import script from "./MenuPreview.vue?vue&type=script&lang=js"
export * from "./MenuPreview.vue?vue&type=script&lang=js"
import style0 from "./MenuPreview.vue?vue&type=style&index=0&id=2c8b92f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8b92f8",
  null
  
)

export default component.exports